// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { TournamentPrizePoolType } from "types/Tournament";

import "./styles.sass";

interface ITournamentBoard {
  prizes: TournamentPrizePoolType[];
}

const TournamentBoard: React.FC<ITournamentBoard> = ({ prizes }) => {
  const t = useTranslate();

  return (
    <div className="TournamentBoard">
      <div className="TournamentBoard__title">
        {t("page.tournament.prize.title")}
      </div>
      <div className="TournamentBoard__wrapper">
        <div className="TournamentBoard__header">
          <div className="TournamentBoard__header_item">
            {t("page.tournament.ranking")}
          </div>
          <div className="TournamentBoard__header_item">
            {t("page.tournament.winning")}
          </div>
        </div>
        {prizes.map((el, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="TournamentBoard__row">
            <div className="TournamentBoard__row_item">{el.place}</div>
            <div className="TournamentBoard__row_item">{el.prize} EUR</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TournamentBoard;
